import { useState } from 'react';

const DEFAULT_PARTNER = {
  name: '',
  nationality: '',
  civilStatus: '',
  profession: '',
  rg: '',
  orgaoEmissor: '',
  cpf: '',
  address: { street: '', number: '', neighborhood: '', city: '', state: '', zipCode: '' },
  contact: { phone: '', email: '' },
};

export function useContractPartner() {
  const [partnerData, setPartnerData] = useState(() => structuredClone(DEFAULT_PARTNER));
  const [partnerExtras, setPartnerExtras] = useState([]);

  return {
    partnerData, setPartnerData,
    partnerExtras, setPartnerExtras,
    DEFAULT_PARTNER,
  };
}
